// extracted by extract-css-chunks-webpack-plugin
module.exports = {"avatar":"app-components-kit-avatar-avatar--avatar"};